module.exports = __webpack_public_path__ + "3f9bb425f35d2cc863af8264f21fe6a6.pdf";